import { render, staticRenderFns } from "./PAmount.vue?vue&type=template&id=6475f91b"
import script from "./PAmount.vue?vue&type=script&lang=js"
export * from "./PAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports